<ng-container *ngIf="isLoading; else resetTempalte">
    <div class="row">
        <div class="col-sm-10 offset-sm-1 col-md-10 offset-md-1 offset-lg-2 col-lg-7 col-xl-4 offset-xl-3">
            <gt-loading></gt-loading>
        </div>
    </div>
</ng-container>

<ng-template #resetTempalte>
    <section>
        <!---Reset Form--->
        <section class="row form-container w-185">
            <ng-container *ngIf="!invalidTokenInfo;else invalidToken">
                <header class="mb-7">
                    <div class="text-12gpx font-bold font-body-bold opacity-90 text-text-default">Reset your password</div>
                </header>
                <div class="form-container w-185 flex flex-col">
                    <form name="form" #reset="ngForm" (ngSubmit)="onSubmit()" novalidate>
                        <div class="form-group mb-0">
                            <ng-container *ngIf="errorMessage && reset.valid && isSubmitted">
                              <div class="text-danger-400 text-xs mt-0.2">{{errorMessage}}</div>
                            </ng-container>
                        </div>
                        <div class="form-group pwd-policy-wrapper">
                            <label for="newPassword" class="mb-2 text-6gpx block font-semibold text-title-default font-body-semibold">New Password</label>
                            
                            <ng-container *ngIf="passwordPolicy.policyEnabled && showPolicy">
                                <div class="policy-box bg-white w-full px-6 py-2 h-auto shadow-md font-body mx-auto">
                                    <ul class="list-unstyled w-full">
                                        <div class="text-text-default flex justify-between mb-2">
                                            <h6 class="text-6gpx font-body-semibold">Password Policy</h6>
                                        </div>
                                        <div class="relative">
                                            <div class="overflow-hidden mb-4 text-xs flex rounded bg-secondary-100 h-0.2 bg-std-background">
                                              <div class="hr-inner" [ngStyle]="{width: getPassedChecksPercentage}"></div>
                                            </div>
                                        </div>
                                        <li class="pwd-policy-item">
                                            <div class="gt-icon"
                                                 [ngClass]="{'gt-icon-checked-circle': (!newPassword.hasError('required') && !newPassword.hasError('minlength')) && newPassword.dirty,
                                                    'gt-icon-cross-circle': newPassword.pristine || (newPassword.dirty && (newPassword.hasError('required') || newPassword.hasError('minlength')))}"></div>
                                            <p class="pwd-policy-text w-100" [ngStyle]="{'color': (!newPassword.hasError('required') && !newPassword.hasError('minlength') && newPassword.dirty) ? '#48A84D' : ''}">
                                                {{passwordPolicyNote?.minimumPasswordLength}}</p>
                                        </li>
                                        <li class="pwd-policy-item">
                                            <div class="gt-icon"
                                                 [ngClass]="{'gt-icon-checked-circle': (!newPassword.hasError('required') && !newPassword.hasError('maxlength')) && newPassword.dirty,
                                                        'gt-icon-cross-circle': newPassword.pristine || (newPassword.dirty && (newPassword.hasError('required') || newPassword.hasError('maxlength')))}"></div>
                                            <p class="pwd-policy-text w-100" [ngStyle]="{'color': (!newPassword.hasError('required') && !newPassword.hasError('maxlength') && newPassword.dirty) ? '#48A84D' : ''}">
                                                {{passwordPolicyNote?.maximumPasswordLength }}</p>
                                        </li>
                                        <li class="pwd-policy-item" *ngIf="passwordPolicy.complexity">
                                            <div class="gt-icon"
                                                 [ngClass]="{'gt-icon-checked-circle': (!newPassword.hasError('required') && !newPassword.hasError('pattern')) && newPassword.dirty,
                                                    'gt-icon-cross-circle': newPassword.pristine || (newPassword.dirty && (newPassword.hasError('required') || newPassword.hasError('pattern')))}"></div>
                                            <p class="pwd-policy-text w-100" [ngStyle]="{'color': (!newPassword.hasError('required') && !newPassword.hasError('pattern') && newPassword.dirty) ? '#48A84D' : ''}">
                                                {{passwordPolicyNote?.allowedSpecialChar}}</p>
                                        </li>
                                        <li *ngIf="passwordPolicy.memory" class="pwd-policy-item">
                                            <div class="gt-icon pwd-policy-text ml-0 text-right">4.</div>
                                            <p class="pwd-policy-text w-100">{{ passwordPolicyNote?.memory}}</p>
                                        </li>
                                        <li *ngIf="passwordPolicy.maxPasswordAge" class="pwd-policy-item">
                                            <div class="gt-icon pwd-policy-text ml-0 text-right">5.</div>
                                            <p class="pwd-policy-text w-100">
                                                {{passwordPolicyNote?.maxPasswordAge}}</p>
                                        </li>
                                        <li *ngIf="passwordPolicy.newPwdChangeDays" class="pwd-policy-item">
                                            <div class="gt-icon pwd-policy-text ml-0 text-right">6.</div>
                                            <p class="pwd-policy-text w-100">
                                                {{passwordPolicyNote?.newPwdChangeDays}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                            
                            <input type="password"
                                    class="form-control placeholder-gray-300 h-21 w-full text-text-default border border-solid rounded-gt-md-4 focus:outline-none text-7gpx p-3 font-bold font-body-bold pwd-input"
                                    name="newPassword"
                                    id="newPassword"
                                    autocomplete="off"
                                    placeholder="New Password"
                                    [(ngModel)]="resetPwdForm.newPassword"
                                    [minlength]="passwordPolicy.policyEnabled ? passwordPolicy.minimumPasswordLength: null"
                                    [maxlength]="passwordPolicy.policyEnabled ? passwordPolicy.maximumPasswordLength: null"
                                    [pattern]="passwordPolicy.policyEnabled ? passwordPolicy.pwdRegex: null"
                                    [ngClass]="{'border-danger': confirmPassword?.errors?.equalTo && isSubmitted && reset.invalid
                                        && (!newPassword?.errors?.required || !confirmPassword?.errors?.required)}"
                                    #newPassword="ngModel"
                                    (ngModelChange)="onDataChange($event)"
                                    (focus)="onPasswordFocus()"
                                    (blur)="onPasswordBlur()"
                                    required/>
                            <div class="text-danger-400 text-xs mt-0.2" *ngIf="(newPassword.invalid && (newPassword.dirty || isSubmitted)) && !newPassword.errors?.required">Password doesn’t match the policy guidelines.</div>
                            <div class="text-danger-400 text-xs mt-0.2" *ngIf="newPassword.errors?.required && (newPassword.dirty || isSubmitted)">Enter a new password.</div>

                        </div>
                        <div class="form-group mb-8 pwd-policy-wrapper">
                            <label for="confirmPassword" class="mb-2 text-6gpx block font-semibold text-title-default font-body-semibold">Confirm Password</label>
                            <input type="password"
                                    class="form-control placeholder-gray-300 h-21 text-text-default border border-solid w-full rounded-gt-md-4 focus:outline-none text-7gpx p-3 font-bold font-body-bold"
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    placeholder="Confirm Password"
                                    autocomplete="off"
                                    [(ngModel)]="resetPwdForm.confirmPassword"
                                    [ngClass]="{'border-danger': confirmPassword?.errors?.equalTo && isSubmitted && reset.invalid
                                        && (!newPassword?.errors?.required || !confirmPassword?.errors?.required)}"
                                    #confirmPassword="ngModel"
                                    [equalTo]="newPassword"
                                    (ngModelChange)="errorMessage=''"
                                    required/>
                            <div class="text-danger-400 text-xs mt-0.2" *ngIf="(confirmPassword.errors?.required) && (confirmPassword.dirty || isSubmitted)">Enter a confirm password.</div>
                            <div class="text-danger-400 text-xs mt-0.2" *ngIf="confirmPassword?.errors?.equalTo && isSubmitted && reset.invalid && (!newPassword?.errors?.required || !confirmPassword?.errors?.required)">Passwords do not match, please re-enter.</div>
                        </div>
                        <div class="form-group mb-0">
                            <button [disabled]="isSubmitting"
                                type="submit"
                                class="mb-4 bg-primary h-21 items-center justify-center text-white flex w-full text-7gpx font-semibold rounded-gt-md-3 font-body-semibold">
                                Reset my password
                            </button>
                            <div class="flex w-full justify-end font-body">
                                <a type="button" class="text-primary text-7gpx font-semibold cursor-pointer font-body-semibold"
                                    (click)="returnToLogin()">
                                    Back to Login
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </ng-container>
        </section>

        <!---Error State--->
        <section class="row">
            <ng-template #invalidToken>
                <div class="form-container w-185 flex flex-col">
                    <error-state [invalidTokenInfo]="invalidTokenInfo"
                                 [tokenStatus]="tokenStatus"
                                 [domainName]="domainName"
                                 [guid]="resetPwdForm.guid">
                    </error-state>
                </div>
            </ng-template>
        </section>
    </section>

</ng-template>
